import script from "./ToastComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToastComponent.vue?vue&type=script&setup=true&lang=ts"

import "./ToastComponent.vue?vue&type=style&index=0&id=3cd2e790&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cd2e790"]])

export default __exports__